<div class="tab-body-top">
  <h3 *ngIf="isOrgType">Clubs / Chapters</h3>
  <h3 *ngIf="isSchool">Chapters</h3>

  <div class="job-search">
    <input type="text" [(ngModel)]="term" (keyup.enter)="onSearch(term)" placeholder="Search chapter/group..." />
    <button>
      <svg viewBox="0 0 18 18">
        <use href="#search" />
      </svg>
    </button>
  </div>
</div>
<div class="block">
  <app-loader-2 *ngIf="!groups.items; else body"></app-loader-2>
  <ng-template #body>
    <section class="chapters">
      <div class="d-flex flex-wrap flex-column flex-md-row">
        <div class="chapter-item d-flex" *ngIf="!isMy; else newPost">
          <div
            class="add-item d-flex flex-column align-items-center justify-content-center"
            (click)="onNewAttachedSchoolClubOrChaterGroup(); false"
          >
            <div class="icon">
              <svg viewBox="0 0 36 36">
                <use href="#profile-plus-green" />
              </svg>
            </div>

            Create a club
          </div>
        </div>

        <ng-template #newPost>
          <div class="chapter-item d-flex" (click)="openPostDialog()" *ngIf="groups.items?.length">
            <div class="add-item d-flex flex-column align-items-center justify-content-center">
              <div class="icon">
                <svg viewBox="0 0 36 36">
                  <use href="#profile-plus-green" />
                </svg>
              </div>

              Create a post for chapters
            </div>
          </div>
        </ng-template>

        <div class="chapter-item d-flex" *ngFor="let group of groups.items">
          <div class="chapter-icon">
            <a [group]="group">
              <img [src]="group.icon | baseUrl" class="img-fluid" />
            </a>
          </div>
          <div class="chapter-data">
            <div class="chapter-title">
              <a [group]="group">{{ group.name }}</a>
            </div>
            <div class="chapter-sub"> {{ group.members }} members </div>
            <div class="chapter-description"> {{ group.description | textTruncate: 100 }} </div>
            <a
              href=""
              *ngIf="!(group.is_requested || group.is_subscriber); else friendBlock"
              (click)="onJoin(group.id); $event.stopPropagation(); false"
              class="chapter-link"
            >
              Join group
            </a>
            <ng-template #friendBlock>
              <a href="" (click)="onLeave(group.id); $event.stopPropagation(); false" class="chapter-link"
                >Leave group</a
              >
            </ng-template>
          </div>
        </div>
      </div>
    </section>
    <div class="d-flex justify-content-center justify-content-md-end mt-md-auto mr-md-3 mb-3">
      <app-page-counter
        *ngIf="groups.amountOfPages"
        [currentPage]="page"
        [amountOfPages]="groups.amountOfPages"
        (setPage)="onSetPage($event)"
        class="mt-md-auto"
      ></app-page-counter>
    </div>
  </ng-template>
</div>
